<template lang="pug">

  v-container
    template(v-if="doc!=null")
      h2 Документы по судебному делу  № {{ caseNumber }}

      h4.mt-3
        i Кому:
      div(v-if="doc.sendable!=null && doc.sendable.type=='FileRequest'")
        template(v-if="doc.sendable.organization") {{ doc.sendable.organization.name }} 
        h4.mt-3
          i Сторона по делу:
        div {{ recipientName(doc.sendable.member) }}

      div(v-else) {{ recipientName(doc.sendable.member) }}

      h4.mt-3
        i E-mail:
      div {{ doc.factAddress }}

      h4.mt-3
        i Документ:
      div {{doc.name}}
    

      h4.mt-3
        i Время и статус:
      div(v-for="point in doc.docRoutePoints")
        span.mr-3 {{point.statusDate}}
        strong {{point.deliveryStatus.title}}

      template(v-if="doc.sendable.text")
        h4.mt-3
          i Текст письма:
        .sended-text(v-if="doc.sendable.text.indexOf('<body>')!=-1" v-html="doc.sendable.text.substring(doc.sendable.text.indexOf('<body>'),doc.sendable.text.indexOf('</body>'))")
        .sended-text(v-else v-html="doc.sendable.text")
            
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    caseId: null,
    docId: null
  },

  mounted() {
    this.$vuetify.theme.dark=false
    this.$store.dispatch('courtCase/DOC_INIT', { caseId: this.caseId, docId:this.docId })
  },

  data () {
    return {
      load: false,
    }
  },

  computed: {
    ...mapGetters('courtCase', ['documents', 'caseNumber']),

    doc () {
      return this.documents.find(d => d.id == this.docId)
    },
  },

  methods: {
    recipientName (member) {
      let { persona } = member
      return (persona.personaType.name == 'UL' && persona.orgName.length > 0) ? persona.orgName : persona.name
    },
  },

}
</script>

<style lang="scss" scoped>
.sended-text {border:1px solid #CCC; padding: 10px; margin-top:10px;}
</style>

